module.exports = __webpack_public_path__ + "img/arlo-2.8ab9062e.webp";